export default __webpack_public_path__ + "static/media/bubble_1_left.53b41b49.png";